import GlobalSearchModal from './GlobalSearchModal';
import TaxRateEditorModal from './TaxRateEditorModal';

const ModalRegistry = () => {
  return (
    <>
      <GlobalSearchModal />
      <TaxRateEditorModal />
    </>
  );
};

export default ModalRegistry;
